import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export enum BulkEmailStatusEnum {
  Created = 'created',
  Working = 'working',
  Done = 'done',
  Error = 'error'
}

export enum BulkEmailRecipientStatusEnum {
  Pending = 'pending',
  Sent = 'sent',
  Failed = 'failed'
}

export class IBulkEmailRecipient {
  email: string;
  name?: string;
  status: BulkEmailRecipientStatusEnum;
  error?: string;
  sentAt?: string;
}

export class IBulkEmailStats {
  total: number;
  sent: number;
  failed: number;
}

export class IBulkEmail {
  id: string;
  creatorId: number;
  creatorName?: string;
  subject: string;
  body: string;
  signature?: string;
  ccAll: boolean;
  cc: string[];

  @Type(() => Object)
  recipients: IBulkEmailRecipient[];

  @Type(() => Object)
  stats: IBulkEmailStats;

  status: BulkEmailStatusEnum;
  errorMessage?: string;
  createdAt: string;
  updatedAt: string;
}

export class IBulkEmailResponse {
  @Type(() => IBulkEmail)
  result: IBulkEmail;
}

export class IBulkEmailListResponse extends IPagination {
  @Type(() => IBulkEmail)
  results: IBulkEmail[];
  total: number;
}

export class IBulkEmailQueryDto extends IQueryPaginationDto {
  creatorId?: number;
  status?: BulkEmailStatusEnum;
  subject?: string;
}

export interface IBulkEmailRecipientInput {
  email: string;
  name?: string;
}

export interface IBulkEmailPostDto {
  subject: string;
  body: string;
  signature?: string;
  ccAll?: boolean;
  cc?: string[];
  recipients: IBulkEmailRecipientInput[];
}

export interface IBulkEmailSuggestion {
  subject: string;
  body: string;
}

export interface IBulkEmailSuggestRequestDto {
  prompt: string;
  count?: number;
}

export interface IBulkEmailSuggestResponse {
  suggestions: IBulkEmailSuggestion[];
}
